<template>
    <div>
        <template v-if="isAlmoxarifado">
            <rkm-layout-body :title="title">
                <rkm-layout-content no-card-style>
                    <Index />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body :title="title">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>almoxarifado</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </div>
</template>

<script>
import Index from '@/components/almoxarifado/requisicao-pendente-permissao/Index'

import { mapGetters } from 'vuex'

import tipoSetor from '@/enums/cadastro/estabelecimento/setorTipo'

export default {
    components: { Index },
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto' }),
        isAlmoxarifado() {

            return this.centroCusto.setor.tipoId == tipoSetor.ALMOXARIFADO
        }
    },
    data: () => ({
        title: 'Requisição pendente e permissão',
        enums: { tipoSetor }
    })
}
</script>